export const checklistForm = {
  description: {
    value: "",
    props: {
      clearable: true,
      "auto-grow": true,
      outlined: true,
      placeholder: "Describe el tipo de incidencia"
    }
  },
  terms: {
    value: false
  }
};
